<template>
  <div class="thirdPay" :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }">
    <van-nav-bar
      title="活动日历锁定到手优惠"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="main">
      <img src="./../../assets/double/img2.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isiOSX: false,
    };
  },
  methods: {
    //返回
    onClickLeft() {
      this.params("", "", "goBack");
    },
  },
  created() {
    this.isiOSX = this.isIphoneX();
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.thirdPay {
  display: flex;
  flex-direction: column;
  background: #f5f6f7;
  height: 100%;
  box-sizing: border-box;
  .main {
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    overflow-y: scroll;
    flex: 1;
    img {
      width: 100%;
      display: block;
    }
  }
}
</style>
<style lang="less">
.thirdPay {
  .van-nav-bar {
    background: none;
    height: 44px;
    .van-nav-bar__left {
      .van-icon {
        color: #000;
        font-size: 18px;
        font-weight: bold;
      }
    }
    .van-nav-bar__title {
      font-size: 18px;
      color: #333333;
      font-weight: 600;
    }
  }
  [class*="van-hairline"]::after {
    border-bottom: solid 1px #f5f6f7;
  }
}
</style>